import React, { useContext } from "react"
import Layout from "../common/layout/layout"
import SEO from "../common/seo/seo"
import CalculatorContainer from "../modules/calculator/CalculatorContainer"
import LocaleContext, { LocaleProvider } from "../context/LocaleContext"
import translate, { keys } from "../translation/translator"

const CalorieCalculator = () => {
  const locale = useContext(LocaleContext)
  return (
    <Layout>
      <SEO
        title={translate(keys.GL_CALCULATOR_META_TITLE, locale)}
        description={translate(keys.GL_CALCULATOR_META_DESCRIPTION, locale)}
      />
      <LocaleProvider>
        <CalculatorContainer />
      </LocaleProvider>
    </Layout>
  )
}

export default CalorieCalculator
